import graphql__1eb0ac6fd033403c3015 from "./__generated__/DeletePlannedItemDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import Section from "../form/Section";
import FormDialog from "./FormDialog";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {DeletePlannedItemDialogMutation} from "./__generated__/DeletePlannedItemDialogMutation.graphql";

type Props = {
    plannedItem: {
        id: string
        definition: {
            name: string
        }
    }
    onClose: (changed: boolean) => void
}

const DeletePlannedItemDialog: React.FC<Props> = ({plannedItem, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<DeletePlannedItemDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__1eb0ac6fd033403c3015,
                variables: {input: {id: plannedItem.id}},
                onCompleted: (_, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    onClose(true);
                },
                onError: (error) => {
                    console.error(error);
                    onClose(false);
                },
            },
            addError,
            {customErrorMessage: intl.formatMessage({id: 'errors.failedToRemovePlannedItem'})}
        );
    };

    return (
        <FormDialog handleCloseDialog={() => onClose(false)}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.DeletePlannedItemDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.delete'})}
                    dangerous={true}>
            <Section>
                <p className="text-sm text-gray-600">
                    {intl.formatMessage({id: 'dialog.DeletePlannedItemDialog.confirmMessage'}, {name: plannedItem.definition.name})}
                </p>
            </Section>
        </FormDialog>
    );
};

export default DeletePlannedItemDialog;
